export default __webpack_public_path__ + "4652677e25dd9aaafe397500d253cf9f.png";